import React, { useState } from "react";
import { Box, Modal, Typography } from "@material-ui/core";

const modalBoxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '5px solid #ff0000',
  borderRadius: '5px',
  boxShadow: 24,
  p: 4,
  backgroundColor: '#fff',
  textAlign: 'center'
};

const ActionConfirmModal = ({ action, onClose, onConfirm }) => {
  const [modalOpen, setModalOpen] = useState(true);

  const handleConfirmAction = () => {
    onConfirm();
    setModalOpen(false);
    onClose();
  };

  return (
    <Modal
      open={modalOpen}
      onClose={() => {
        setModalOpen(false);
        onClose();
      }}
    >
      <Box sx={modalBoxStyle}>
        <Typography variant="h6" component="h2" style={{ marginBottom: '20px', color: '#000' }}>
          Are you sure you want to {action}?
        </Typography>
        <div style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
          <button
            onClick={() => onClose()}
            style={{
              padding: '10px 20px',
              border: '2px solid #666',
              borderRadius: '5px',
              backgroundColor: '#fff',
              color: '#666',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleConfirmAction}
            style={{
              padding: '10px 20px',
              border: '2px solid #ff0000',
              borderRadius: '5px',
              backgroundColor: '#ff0000',
              color: '#fff',
              cursor: 'pointer'
            }}
          >
            Confirm
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default ActionConfirmModal; 